import apiHandler from "../core/apiHandler";
const taxpayerAuthenticationConfigApi = apiHandler('taxpayer-authentication-config');
export default taxpayerAuthenticationConfigApi;
